module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "item wrap",
    class: _vm.classItem,
    attrs: {
      "to": _vm.linkToPage
    }
  }, [_c('p', {
    staticClass: "identification"
  }, [_c('span', [_vm._v("\n            Distributeur\n            "), _c('strong', {
    staticClass: "distributeur"
  }, [_vm._v(_vm._s(_vm.bouteille.fournisseur.nom))])]), _vm._v(" "), _c('br'), _vm._v(" Bouteille\n        "), _c('strong', {
    staticClass: "nom"
  }, [_vm._v(_vm._s(_vm.bouteille.nom.nom))]), _vm._v(" "), (_vm.bouteille.marque) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("\n                Marque\n                "), _c('strong', {
    staticClass: "marque"
  }, [_vm._v(_vm._s(_vm.bouteille.marque))])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "floating"
  }, [(_vm.bouteille.favori !== null && _vm.bouteille.favori != undefined && _vm.$user && _vm.bouteille.favori.id === _vm.$user.id) ? _c('div', {
    staticClass: "favori"
  }, [_c('i', {
    staticClass: "icon-star"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "id-bouteille"
  }, [_c('i', {
    staticClass: "icon-gas"
  }), _vm._v("\n            " + _vm._s(_vm.bouteille.code) + "\n        ")]), _vm._v(" "), (_vm.bouteille.fluide) ? _c('div', {
    staticClass: "refrigerant",
    class: _vm.bouteille.fluide.regenerated ? 'regen' : ''
  }, [_c('i', {
    staticClass: "icon-fluid"
  }), _vm._v("\n            " + _vm._s(_vm.bouteille.fluide.nom) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bouteille.type !== 'Fluide frigorigène' && _vm.bouteille.poids_net !== 0) ? _c('div', {
    staticClass: "refrigerant",
    staticStyle: {
      "color": "orange"
    }
  }, [_c('i', {
    staticClass: "icon-link"
  }), _vm._v("\n            " + _vm._s(_vm.info) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bouteille.otag) ? _c('div', {
    staticClass: "otag"
  }, [_c('i', {
    staticClass: "icon-otag"
  }), _vm._v("\n            " + _vm._s(_vm.bouteille.otag) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.bouteille.otag) ? _c('span', {
    staticClass: "level-bar"
  }, [_c('span', {
    staticClass: "full-level"
  }), _vm._v(" "), _c('span', {
    staticClass: "level",
    style: (_vm.styleObj)
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f4c3382","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/BouteilleItem.vue
// module id = 743
// module chunks = 0